'use strict';

var React = require('react');

var SvgRemoveBackgroundIcon = function SvgRemoveBackgroundIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.47 16.47c-.293.293-.293.767 0 1.06.293.293.767.293 1.06 0l14-14c.293-.293.293-.767 0-1.06-.293-.293-.767-.293-1.06 0l-14 14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47 9.53c-.293-.293-.293-.767 0-1.06l6-6c.293-.293.767-.293 1.06 0 .293.293.293.767 0 1.06l-6 6c-.293.293-.767.293-1.06 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47 5.53c-.293-.293-.293-.767 0-1.06l2-2c.293-.293.767-.293 1.06 0 .293.293.293.767 0 1.06l-2 2c-.293.293-.767.293-1.06 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.47 16.47c-.293.293-.293.767 0 1.06.293.293.767.293 1.06 0l6-6c.293-.293.293-.767 0-1.06-.293-.293-.767-.293-1.06 0l-6 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47 17.53c-.293-.293-.293-.767 0-1.06l10-10c.293-.293.767-.293 1.06 0 .293.293.293.767 0 1.06l-10 10c-.293.293-.767.293-1.06 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47 12.47c-.293.293-.293.767 0 1.06.293.293.767.293 1.06 0l10-10c.293-.293.293-.767 0-1.06-.293-.293-.767-.293-1.06 0l-10 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.47 17.53c-.293-.293-.293-.767 0-1.06l2-2c.293-.293.767-.293 1.06 0 .293.293.293.767 0 1.06l-2 2c-.293.293-.767.293-1.06 0Z"
  }));
};
SvgRemoveBackgroundIcon.displayName = "RemoveBackgroundIcon";

exports.SvgRemoveBackgroundIcon = SvgRemoveBackgroundIcon;
